/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useMemo, useEffect } from 'react';
import {
  ModalOverride,
  ModalContent,
  ChipsContainer,
  CheckBoxContainer,
  TitleColumn,
  ChipsInputWrapper
} from './styles';

import { Checkbox, Modal } from '@gerdau/hefesto';
import { Chips } from '@gerdau/hefesto-mais-web';
import {
  flatSteelItems,
  materialCodeType,
  OrderPreferencesProps
} from '../OrdersTable';
import { EOrderTab } from '../../../../store/ducks/long-steel-orders/types';

export type TableContextType = EOrderTab;

interface OrdersPersonalizeModalProps {
  canShow: boolean;
  tableType: TableContextType;
  hasFlatsteel: boolean;
  hasFutureDeliveries: boolean;
  orderPreferences: OrderPreferencesProps;
  onClose: () => void;
  onUpdate: (e: OrderPreferencesProps) => void;
}

export const openOrderSections = [
  {
    id: 'identificacao',
    title: 'Identificação',
    items: [
      {
        value: 'customerOrder',
        label: 'Identificação do pedido',
        disabled: true
      },
      { value: 'salesOrder', label: 'Nº da ordem de venda', disabled: true },
      { value: 'emitter', label: 'Emissor' },
      { value: 'receiver', label: 'Recebedor' }
    ]
  },
  {
    id: 'produtos',
    title: 'Produtos',
    items: [
      { value: 'codeAndDescription', label: 'Código e descrição' },
      { value: 'orderStatus', label: 'Status do pedido' },
      { value: 'sku', label: 'Código do material' },
      { value: 'materialDescription', label: 'Descrição do material' },
      { value: 'totalQuantityRequested', label: 'Quantidade solicitada' },
      { value: 'totalQuantityConfirmed', label: 'Quantidade confirmada' },
      { value: 'totalQuantityPending', label: 'Saldo' },
      { value: 'totalQuantityDelivery', label: 'Em remessa' },
      { value: 'totalQuantityShipment', label: 'Em carregamento' },
      { value: 'totalQuantityBilled', label: 'Faturado' },
      { value: 'salesOrderItem', label: 'Nº do item' },
      { value: 'divisionDescription', label: 'Tipo de produto' }
    ]
  },
  {
    id: 'acos_planos',
    title: 'Produção de aços planos',
    items: [
      { value: 'productionStatus', label: 'Status de produção' },
      { value: 'meltShop', label: 'Aciaria' },
      { value: 'rollingMill', label: 'Laminação' },
      { value: 'rollingFinish', label: 'LA' },
      { value: 'finish', label: 'Acabamento' },
      { value: 'stockMill', label: 'Estoque usina' },
      { value: 'transit', label: 'Em transferência' },
      { value: 'stockWarehouse', label: 'Estoque entre-posto' }
    ]
  },
  {
    id: 'pagamento',
    title: 'Pagamento',
    items: [
      { value: 'paymentCondition', label: 'Condição de pagamento' },
      { value: 'unitPriceTax', label: 'Preço unitário c/ impostos' },
      { value: 'unitPriceNoTax', label: 'Preço unitário s/ impostos' },
      { value: 'totalPriceTax', label: 'Preço total c/ impostos' },
      { value: 'totalPriceNoTax', label: 'Preço total s/ impostos' }
    ]
  },
  {
    id: 'outras',
    title: 'Outras informações',
    items: [
      { value: 'requestedDateTable', label: 'Data desejada' },
      { value: 'nextEstimatedDate', label: 'Próxima data estimada' },
      { value: 'deliveryStatus', label: 'Status de entrega' },
      { value: 'creationDateTable', label: 'Data de criação' },
      { value: 'futureDeliveriesDate', label: 'Data estimada' },
      { value: 'futureDeliveriesQuantity', label: 'Qtd. entrega' },
      { value: 'futureDeliveriesUnit', label: 'Un. entrega' }
    ]
  }
];

const billedOrderSections = [
  {
    id: 'identificacao',
    title: 'Identificação',
    items: [
      {
        value: 'customerOrder',
        label: 'Identificação do pedido',
        disabled: true
      },
      { value: 'salesOrder', label: 'Nº da ordem de venda', disabled: true },
      { value: 'danfeNumber', label: 'Nº da nota fiscal' },
      { value: 'emitter', label: 'Emissor' },
      { value: 'receiver', label: 'Recebedor' },
      { value: 'invoiceBillNumber', label: 'Nº da fatura' },
      { value: 'shippingNoteNumber', label: 'Nº da nota de remessa' }
    ]
  },
  {
    id: 'produtos',
    title: 'Produto',
    items: [
      { value: 'codeAndDescription', label: 'Código e descrição' },
      { value: 'billedQuantity', label: 'Qtd. faturada' },
      { value: 'sku', label: 'Código do material' },
      { value: 'materialDescription', label: 'Descrição do material' },
      { value: 'salesOrderItem', label: 'Nº do item' }
    ]
  },
  {
    id: 'pagamento',
    title: 'Pagamento',
    items: [
      { value: 'dueDate', label: 'Data do vencimento' },
      { value: 'paymentCondition', label: 'Condição de pagamento' },
      { value: 'unitPriceTax', label: 'Preço unitário c/ impostos' },
      { value: 'unitPriceNoTax', label: 'Preço unitário s/ impostos' },
      { value: 'totalPriceTax', label: 'Preço total c/ impostos' },
      { value: 'totalPriceNoTax', label: 'Preço total s/ impostos' },
      { value: 'invoiceTotalTax', label: 'Total da fatura c/ impostos' },
      { value: 'invoiceTotalNoTax', label: 'Total da fatura s/ impostos' }
    ]
  },
  {
    id: 'outras',
    title: 'Outras informações',
    items: [
      { value: 'billingDate', label: 'Data do faturamento' },
      { value: 'creationDateTable', label: 'Data de criação' },
      { value: 'accessKey', label: 'Chave de acesso da NF' },
      { value: 'heatNumber', label: 'Corrida' }
    ]
  }
];

const layoutConfig: Record<EOrderTab, string[][]> = {
  [EOrderTab.OPEN]: [
    ['identificacao', 'outras'], // Coluna 1: Identificação em cima, Outras embaixo
    ['produtos'], // Coluna 2: Produtos (alto)
    ['acos_planos'], // Coluna 3
    ['pagamento'] // Coluna 4
  ],
  [EOrderTab.BILLED]: [
    ['identificacao'], // Coluna 1
    ['produtos'], // Coluna 2
    ['pagamento'], // Coluna 3
    ['outras'] // Coluna 4
  ]
};

const chipsData = [
  { id: '0', label: 'Código Gerdau' },
  { id: '1', label: 'Código interno' }
];

const CHIP_SKU = ['0'];
const CHIP_CUSTOMER_SKU = ['1'];

const OrdersPersonalizeModal: React.FC<OrdersPersonalizeModalProps> = ({
  canShow,
  tableType = EOrderTab.BILLED,
  orderPreferences,
  onClose,
  onUpdate,
  hasFlatsteel,
  hasFutureDeliveries
}) => {
  const [preferences, setPreferences] = useState(orderPreferences);
  const [prevCanShow, setPrevCanShow] = useState(canShow);

  if (canShow !== prevCanShow) {
    setPrevCanShow(canShow);
    if (canShow && orderPreferences) {
      setPreferences(orderPreferences);
    }
  }

  useEffect(() => {
    if (canShow && orderPreferences) {
      setPreferences(orderPreferences);
    }
  }, [orderPreferences]);

  const processedSections = useMemo(() => {
    const rawSections =
      tableType === EOrderTab.BILLED ? billedOrderSections : openOrderSections;

    const sectionMap: Record<string, (typeof rawSections)[0]> = {};

    rawSections.forEach((section) => {
      const mappedItems = section.items.map((item) => {
        if (item.value === 'sku') {
          return {
            ...item,
            label:
              preferences.materialCode === 'sku'
                ? 'Código do material'
                : 'Código interno'
          };
        }
        if (item.value === 'codeAndDescription') {
          return {
            ...item,
            label:
              preferences.materialCode === 'sku'
                ? 'Código e descrição'
                : 'Código interno e descrição'
          };
        }
        return item;
      });

      const filteredItems = mappedItems.filter((item) => {
        // Filtro Aços Planos
        if (!hasFlatsteel && flatSteelItems.includes(item.value)) return false;

        // Filtro Entrega Futura
        const futureKeys = [
          'futureDeliveriesDate',
          'futureDeliveriesQuantity',
          'futureDeliveriesUnit'
        ];
        if (!hasFutureDeliveries && futureKeys.includes(item.value))
          return false;

        return true;
      });

      if (filteredItems.length > 0 || section.items.length > 0) {
        sectionMap[section.id] = { ...section, items: filteredItems };
      }
    });

    return sectionMap;
  }, [tableType, hasFlatsteel, hasFutureDeliveries]);

  const currentLayout =
    layoutConfig[tableType as unknown as keyof typeof layoutConfig] ||
    layoutConfig[EOrderTab.OPEN];

  if (!canShow || !orderPreferences) {
    return null;
  }

  const updateTableConfig = ({
    type,
    value
  }: {
    type: 'column' | 'code';
    value: string;
  }) => {
    if (type === 'column') {
      const alreadyHidden = preferences.columnsHidden.some(
        (column) => column === value
      );
      const columnsHidden = [...preferences.columnsHidden, value].filter(
        (column) => (alreadyHidden ? column !== value : column)
      );
      setPreferences((prev) => ({ ...prev, columnsHidden }));
      return;
    }

    setPreferences((prev) => {
      if (prev.materialCode === value) return prev;
      return {
        ...prev,
        materialCode: value as materialCodeType
      };
    });
  };

  const handleSave = () => {
    onUpdate(preferences);
  };

  const modalTitle =
    tableType === EOrderTab.BILLED
      ? 'Personalizar tabela de pedidos faturados'
      : 'Personalizar tabela de pedidos em aberto';

  return (
    <ModalOverride>
      <Modal
        modalSize="lg"
        buttons={{
          left: {
            children: 'Cancelar',
            name: 'Cancelar',
            onClick: onClose,
            type: 'button'
          },
          right: {
            children: 'Salvar personalização',
            name: 'Salvar personalização',
            onClick: handleSave,
            type: 'button'
          }
        }}
        onClose={onClose}
        title={modalTitle}
      >
        <ModalContent>
          <span className="subtitle" style={{ display: 'block' }}>
            Escolha como as informações da tabela serão exibidas de acordo com
            suas preferências.
          </span>

          <CheckBoxContainer hasFlatsteel={hasFlatsteel} tableType={tableType}>
            {currentLayout
              .filter((item) =>
                hasFlatsteel ? true : !item.includes('acos_planos')
              )
              .map(
                (
                  columnIds: string[],
                  colIndex: React.Key | null | undefined
                ) => (
                  <div
                    key={colIndex}
                    style={{
                      flex: '1',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '24px'
                    }}
                  >
                    {columnIds.map((sectionId) => {
                      const sectionData = processedSections[sectionId];

                      return (
                        <div key={sectionId}>
                          <TitleColumn>{sectionData?.title}</TitleColumn>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '8px'
                            }}
                          >
                            {sectionData?.items?.map((item) => {
                              const isChecked =
                                !preferences.columnsHidden.includes(item.value);
                              return (
                                <Checkbox
                                  key={item.value}
                                  label={item.label}
                                  checked={isChecked}
                                  name={item.value}
                                  disabled={item.disabled}
                                  onChange={() =>
                                    updateTableConfig({
                                      type: 'column',
                                      value: item.value
                                    })
                                  }
                                />
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )
              )}
          </CheckBoxContainer>

          <ChipsContainer>
            <span style={{ fontSize: '14px', color: '#666' }}>
              Selecione qual o tipo de código de material deseja exibir na
              coluna.
            </span>
            <ChipsInputWrapper>
              <Chips
                type={'choice'}
                selectedChipIds={
                  preferences.materialCode === 'sku'
                    ? CHIP_SKU
                    : CHIP_CUSTOMER_SKU
                }
                handleSelect={(e) =>
                  updateTableConfig({
                    type: 'code',
                    value: e.includes('0') ? 'sku' : 'customerSKU'
                  })
                }
                chips={chipsData}
              />
            </ChipsInputWrapper>
          </ChipsContainer>
        </ModalContent>
      </Modal>
    </ModalOverride>
  );
};

export default OrdersPersonalizeModal;
